// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diamonds__buy-btn{margin:0;padding:1rem 2rem;border:none;color:#fff;background-color:#111;border-radius:0;cursor:pointer;width:100%;text-transform:uppercase;font-size:.875rem;line-height:.875rem;letter-spacing:.12em;font-weight:400;white-space:nowrap}.diamonds__buy-btn:hover{background-color:#8a8989}", ""]);
// Exports
module.exports = exports;
